import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Autocomplete,
    Box,
    Grid,
    Grow,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Typography,
} from "@mui/material";

import { getBreakDownPlaceByGroupId } from "../../store/actions/GeneralTableActions";
import {
    getPlants,
    getMaintenanceType,
    getMailGroup,
    getMailGroupPeriod,
    addMaintenanceType,
    updateMaintenanceType,
    deleteMaintenanceType
} from "../../store/actions/MaintenanceTypeActions";

import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

export default function MaintenanceType() {
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const { MaintenanceType } = useSelector(
        (MaintenanceType) => MaintenanceType
    );

    const [pageLoaded, setPageLoaded] = useState(false);
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");

    const [isAddDisable, setIsAddDisable] = useState(true);

    //tabloyla alakali stateler
    const [plantList, setPlantList] = useState([]);

    //Sayfanin ilk acilmasiyla alakali stateler
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
 

    useEffect(() => {
        getMailGroupHandler();
        getMailGroupPeriodHandler();
        getPlantCodeHandler();
        loadHandler();

    }, []);


    useEffect(() => {
        if (MaintenanceType?.maintenanceTypes?.length) {
            setInitialRows(MaintenanceType.maintenanceTypes);
            setRows(MaintenanceType.maintenanceTypes);
            MaintenanceType.maintenanceTypes = {};
            setPageLoaded(true);
        }

        if (MaintenanceType.mailGroup) {
            setMailGroupList(MaintenanceType.mailGroup);
        }

        if (MaintenanceType.mailGroupPeriod) {
            setMailPeriodList(MaintenanceType.mailGroupPeriod);
        }
        if (MaintenanceType?.plants?.resultObject) {
            setPlantList(MaintenanceType.plants.resultObject);
        }
        if (MaintenanceType.isTaskUpdated) {
            setEditableRow(false);
            setDisableButton(false);
            loadHandler();
        }
    }, [MaintenanceType]);

    const loadHandler = () => {
        dispatch(getMaintenanceType());
    };

     //get mail groups
     const [mailGroupList, setMailGroupList] = useState([]);
     const getMailGroupHandler = () => {
       dispatch(getMailGroup());
     };
 
     // Mail Group Period
     const [mailPeriodList, setMailPeriodList] = useState([{ code: 0, description: "" }]);
     const getMailGroupPeriodHandler = () => {
         dispatch(getMailGroupPeriod());
     };

    const getPlantCodeHandler = () => {
        dispatch(getPlants());
    };


    //Sayfayla alakali
    let [addMailGroupID, setAddedMailGroupID] = useState(null);
    let [addMailGroupName, setAddedMailGroupName] = useState(null);
    let [mailPeriodId, setMailPeriodId] = useState(null);

    //Degisiklik yok
    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return <TableCell align="center">{t("Actions")}</TableCell>;
            } else {
                return isSortingAction ? (
                    <TableCell align="center" id={`mt_TableHead_${index}`}>
                        <TableSortLabel
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() =>
                                handleSort(cloneObject(initialRows), item.id)
                            }
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

     //dynamic sort function
     let [sortOrder, setSortOrder] = useState();
     let [sortColumn, setSortColumn] = useState();

     //Degisiklik yok
     const handleSort = (row, column) => {
         const sortedList = commonSort(row, column);
         setSortOrder(sortedList[0]);
         setSortColumn(sortedList[1]);
         setInitialRows(sortedList[2]);
         setRows(sortedList[2]);
     };

     const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

     // Pagination
     const [currentPage, setCurrentPage] = useState(0);
     const [rowsPerPage, setRowsPerPage] = useState(20);
     const handleChangePage = (_event, newPage) => {
         setCurrentPage(newPage);
     };
 
     const handleChangeRowsPerPage = (event) => {
         setRowsPerPage(+event.target.value);
         setCurrentPage(0);
     };

    //set plantID degisiklik yok
    let [addPlantID, setAddedPlantID] = useState(0);
    let [addPlantName, setAddedPlantName] = useState("");
    const newPlantID = (plantCode) => {
        if (plantCode) {
            const filteredPlant = plantList.filter((item) =>
                item.code.includes(plantCode)
            );
            setAddedPlantID(filteredPlant[0].id);
            setAddedPlantName(filteredPlant[0].name);
            return [filteredPlant[0].id, filteredPlant[0].name];
        } else {
            setAddedPlantID(0);
            setAddedPlantName("");
        }
    };

    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }
        if (value.length > 0) {
            if (obj === "code") {
                setError({ ...error, maintenanceTypeCodeError: "" });
            } else if (obj === "name") {
                setError({ ...error, maintenanceTypeNameError: "" });
            } else if (obj === "plantCode") {
                setError({ ...error, plantTextError: "" });
            }
            
        } else {
            if (obj === "code") {
                setError({ ...error, maintenanceTypeCodeError: t("MaintenanceTypeCodeValidation") });
            } else if (obj === "name") {
                setError({ ...error, maintenanceTypeNameError: t("MaintenanceTypeNameValidation") });
            } else if (obj === "plantCode") {
                setError({ ...error, plantTextError: t("SelectAPlant") });
            }
        }

    };

    const updateAddHandler = (row) => {
        //update
        if (row.id !== "") {
            const data = {
                id: row.id,
                code: row.code,
                name: row.name,
                plantId: row.plantId,
                mailGroupId: addMailGroupID,
                mailGroupName: addMailGroupName,
                mailPeriodId: mailPeriodId,
                status: 1,
            };
            dispatch(updateMaintenanceType(data));
        }
        //add
        else {
            const data = {
                code: row.code,
                name: row.name,
                plantId: addPlantID,
                mailGroupId: addMailGroupID,
                mailGroupName: addMailGroupName,
                mailPeriodId: mailPeriodId,
            };
          
            dispatch(addMaintenanceType(data));
        }
    };

    const disableEditHandler = () => {
        filterData(filterText);
        setEditable(false);
        //enable edit button
        setDisableButton(false);
        setAddedPlantID(0);

        setError({
            maintenanceTypeCodeError: t("MaintenanceTypeCodeValidation"),
            maintenanceTypeNameError: t("MaintenanceTypeNameValidation"),
            plantTextError: t("SelectAPlant"),
        });
    };

    //filter table
    const [filterText, setFilterText] = useState("");
    const [disableButton, setDisableButton] = useState(false);

    // Filter table
    const filterData = (value) => {
        const newFilteredText = value.toLowerCase();
        setFilterText(newFilteredText);
        let filteredItems = cloneObject(initialRows).filter((item) => item.code.toLowerCase().includes(newFilteredText) || item.name.toLowerCase().includes(newFilteredText));
        setRows(filteredItems);
        setDisableButton(false);
    };

    useEffect(() => {
        filterData(filterText);
    }, [initialRows]);

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const enableEditHandler = (row) => {
        if (disableButton || editable) {
            filterData(filterText);
        }
        setAddedMailGroupID(row.mailGroupId);
        setAddedMailGroupName(row.mailGroupName);
        setMailPeriodId(row.mailPeriodId);
        setDisableButton(true);
        newPlantID(row.plantCode);
        setEditableRow(row.id);
        setEditable(true);

        setError({
            maintenanceTypeCodeError: "",
            maintenanceTypeNameError: "",
            plantTextError: "",
        });
    };

    //add blank row for new plant addition
    const addBlankRowHandler = () => {
        setAddedPlantName("");
        setCurrentPage(0);
        setDisableButton(true);
        const addedBlankRow = [
            {
                id: "",
                code: "",
                name: "",
                plantCode: "",
                plantName: "",
            },
        ];

        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    const deleteHandler = (row) => {
        toggleModal();
        const data = {
            id: row.id,
            code: row.code,
            name: row.name,
            plantId: row.plantId,
            breakdownRootCauseLocalizationName: row.breakdownRootCauseLocalizationName,
        };
        dispatch(deleteMaintenanceType(data));
    };

    const [error, setError] = useState({
        maintenanceTypeCodeError: t("MaintenanceTypeCodeValidation"),
        maintenanceTypeNameError: t("MaintenanceTypeNameValidation"),
        plantTextError: t("SelectAPlant"),
    });

    useEffect(() => {
        if (error.plantTextError === "" && error.maintenanceTypeCodeError === "" && error.maintenanceTypeNameError === "") {
            setIsAddDisable(false);
        } else {
            setIsAddDisable(true);
        }
    }, [error]);



    return (
        <StyledTableDiv>
            <h1>
                {t("MaintenanceType")} {t("List")}{" "}
            </h1>
            <AddButton
                onClick={() => addBlankRowHandler()}
                disabled={disableButton}
            />
            {pageLoaded === true ? (
                <Grid
                    container
                    spacing={4}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ marginBottom: 4 }}
                >
                    <Grid item xs={12} sm={12} md={4}>
                        <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => filterData(value)} />
                    </Grid>
                </Grid>
            ) : null}
            <Box m={2} />
            {rows.length > 0 ? (
                <Grow
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...{ timeout: 1000 }}
                >
                    <TableContainer component={Paper}>
                        <Table  id="mt_Table" aria-label="simple table">
                            <TableHead  id="mt_TableHead">
                                <TableRow id="mt_TableRow">
                                    {renderTableCell([
                                        { id: "id", label: t("ID") },
                                        { id: "code", label: t("Code") },
                                        { id: "name", label: t("Name") },
                                        { id: "plantCode", label: t("PlantCode") },
                                        { id: "plantName", label: t("PlantName") },
                                        // { id: "mailGroupName", label: t("MailGroupName") },
                                        // { id: "mailPeriodName", label: t("MailPeriod") },
                                        { id: "Actions", label: t("Actions") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody id="mt_TableBody">
                                {rows
                                    .slice(
                                        currentPage * rowsPerPage,
                                        currentPage * rowsPerPage + rowsPerPage
                                    )
                                    .map((row, index) => (
                                        <React.Fragment key={row.id}>
                                            <TableRow key={row.id} id={`mt_TableRow_${index}`}>
                                            <TableCell align="center" id={`mt_TableCell_${index}`}>{row.id}</TableCell>
                                            <TableCell  align="center" id={`mt_TableCell_1_${index}`}>
                                                {editable && editableRow === row.id ? (
                                                    <TextField onInput={(e) => setRowHandler(e.target.value, "code", row)} defaultValue={row.code} variant="outlined" error={error.maintenanceTypeCodeError.length > 0}
                                                    helperText={error.maintenanceTypeCodeError} FormHelperTextProps ={{id: "mt_val1"}} id={`mt_TextField_${index}`}/>
                                                ) : (
                                                    row.code
                                                )}
                                            </TableCell>
                                            <TableCell align="center"  id={`mt_TableCell_2_${index}`}>
                                                {editable && editableRow === row.id ? (
                                                    <TextField onInput={(e) => setRowHandler(e.target.value, "name", row)} defaultValue={row.name} variant="outlined" error={error.maintenanceTypeNameError.length > 0}
                                                    helperText={error.maintenanceTypeNameError} FormHelperTextProps ={{id: "mt_val2"}} id={`mt_TextField_1_${index}`}/>
                                                ) : (
                                                    row.name
                                                )}
                                            </TableCell>
                                            <TableCell align="center"  id={`mt_TableCell_3_${index}`}>
                                                {editable && editableRow === row.id && editableRow === "" ? (
                                                    <Autocomplete
                                                        id={`mt_AutoComplete_${index}`}
                                                        defaultValue={row.plantCode}
                                                        onChange={(event, newValue) => {
                                                            newValue = newValue ? newValue : "";
                                                            newPlantID(newValue);
                                                            setRowHandler(newValue, "plantCode", row)
                                                        }}
                                                        options={plantList.map((option) => option.code)}
                                                        renderInput={(params) => 
                                                        <TextField {...params} margin="normal" variant="outlined" error={error.plantTextError.length > 0} 
                                                        helperText={error.plantTextError} FormHelperTextProps ={{id: "mt_val3"}} id={`mt_TextField_2_${index}`}/>
                                                    }
                                                    />
                                                ) : (
                                                    row.plantCode
                                                )}
                                            </TableCell>
                                            <TableCell align="center"  id={`mt_TableCell_4_${index}`}> {editable && editableRow === row.id && editableRow === "" ? addPlantName : row.plantName}</TableCell>
                                            {/* <TableCell align="center"  id={`mt_TableCell_5_${index}`}>
                                                {editable && editableRow === row.id ? (
                                                    <Autocomplete
                                                        id={`mt_AutoComplete_1_${index}`}
                                                        defaultValue={row.mailGroupName}
                                                        onChange={(event, newValue) => {
                                                            newMailGroupName(newValue);
                                                        }}
                                                        options={mailGroupList.map((option) => option.name)}
                                                        renderInput={(params) => <TextField  {...params} margin="normal" variant="outlined" id={`mt_TextField_3_${index}`} />}
                                                    />
                                                ) : (
                                                    row.mailGroupName
                                                )}
                                            </TableCell>
                                            <TableCell align="center"  id={`mt_TableCell_6_${index}`}>
                                                {editable && editableRow === row.id ? (
                                                    <Autocomplete
                                                        id={`mt_AutoComplete_2_${index}`}
                                                        defaultValue={row.mailPeriodId ? mailPeriodList.filter((item) => item.code == row.mailPeriodId)[0].description : ""}
                                                        onChange={(event, newValue) => {
                                                            newMailPeriod(newValue);
                                                        }}
                                                        options={mailPeriodList.map((option) => option.description)}
                                                        renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" id={`mt_TextField_4_${index}`} />}
                                                    />
                                                ) : row.mailPeriodId ? (
                                                    mailPeriodList.filter((item) => item.code == row.mailPeriodId)[0].description
                                                ) : (
                                                    ""
                                                )}
                                            </TableCell> */}
                                            <TableButtons
                                                editable={editable}
                                                editableRow={editableRow}
                                                addDisabled={isAddDisable}
                                                row={row}
                                                updateAddHandler={() => updateAddHandler(row)}
                                                disableEditHandler={() => disableEditHandler()}
                                                enableEditHandler={() => enableEditHandler(row)}
                                                deleteButtonHandler={() => deleteButtonHandler(row)}
                                            />
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={currentPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}
            <Modal
                title={t("Delete")}
                content={t("WillYouDoTransaction")}
                approved={() => deleteHandler(deletedRow)}
                isModalOpen={isModalOpen}
                toggle={toggleModal}
            />
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}
